import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconChevronRight = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M15.249 1.948c-1.13.274-1.765 1.513-1.354 2.642.13.357.623.859 13.648 13.89L41.055 32 27.543 45.52C14.518 58.551 14.025 59.053 13.895 59.41c-.274.754-.107 1.552.44 2.1.362.361.556.467 1.041.567.445.092.97.006 1.36-.223.14-.082 6.438-6.336 13.993-13.898C44.234 34.44 44.469 34.2 44.702 33.721c.162-.333.27-.682.342-1.104.097-.572.097-.662 0-1.234a4 4 0 0 0-.342-1.104c-.233-.479-.468-.719-13.973-14.235C23.174 8.482 16.877 2.228 16.736 2.146c-.243-.142-.809-.296-1.043-.285-.06.003-.26.042-.444.087" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconChevronRight.displayName = 'IconChevronRight';